import '.cb{display:inline-flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.k4{padding:0.6rem;}.ssr-plugin'
import '.hn{border-radius:1.875rem;}.ssr-plugin'
import '.k5{border:1px solid var(--palette-blue-50);}.ssr-plugin'
import '.k6{box-shadow:0 1rem 2rem 0.5rem var(--palette-blue-50);}.ssr-plugin'
import '.k7{--page-min-height:auto;}.ssr-plugin'
import '.dh{border-radius:2rem;}.ssr-plugin'
import '.k8{overflow-x:hidden;}.ssr-plugin'
import '.br{overflow-y:auto;}.ssr-plugin'
import '.k9{background:var(--page-bg);}.ssr-plugin'
import '.ac{position:relative;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { ReactNode } from 'react'

export type PhoneFrameProps = {
  children: ReactNode
  width?: number
  height?: number
  style?: Style
}

export const PhoneFrame = ({
  children,
  width = 390,
  height = 760,
  style,
}: PhoneFrameProps) => {
  return (
    <styled.div className="cb e t v k4 hn k5 k6"
      style={{
        ...style,
      }}
    >
      <styled.div className="k7 dh k8 br k9 ac"
        style={{
          width,
          height,} as Style}
      >
        <div style={{ pointerEvents: 'none' }}>{children}</div>
      </styled.div>
    </styled.div>
  )
}
